function generateRandomNum(min, max) {
	min = Math.ceil(min);
  	max = Math.floor(max);
  	return Math.floor(Math.random() * (max - min + 1)) + min;
}
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  } else {
  	return null;
  }
}
function setCookie(name, value, days = 30) {
  const date = new Date();

  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));

  document.cookie =
    `${name}=${value}; expires=${date.toUTCString()}; path=/`;
}
function syncCollectionReviews() {
  $('.card__content .yotpo-widget-instance-custom').each(function () {
    const $this = $(this);
    const productId = $this.attr('data-product');
    const collection = $this.attr('data-collection');
    const namesd = "prod1_";
    if (
      !productId ||
      collection !== 'zebra-skin-rugs'
    ) {
      return;
    }
    
    var proId = productId;
    var origCount = $this.find('.yotpo-reviews-star-ratings-widget .yotpo-sr-bottom-line-text').text();
    var newCount = parseInt(origCount);

    var counter = Math.floor(Math.random() * (76 - newCount + 1)) + newCount;
    origCount = origCount.replace(/[^0-9]/g, '');
    if(origCount >= 5) {
      if(getCookie(namesd+proId) == null) {
        if(getCookie(namesd+proId) == null) {
          setCookie(namesd+proId, counter);
        }
      }
      if(getCookie(namesd+proId) != origCount) {
        $this.find('.yotpo-reviews-star-ratings-widget .yotpo-sr-bottom-line-text').html(getCookie(namesd+proId)+" Reviews");
      }
    } 
  });
}
setInterval(function () {
  syncCollectionReviews();
}, 300);
